import { runMigrations } from '@builder4/shared/migrations/runner';
import { CURRENT_SCHEMA_VERSION, migrations } from '@builder4/shared/migrations/craft/registry';
import { MigratableJson } from './MigratableJson';

export interface MigrationResult<T extends MigratableJson = MigratableJson> {
  json: T;
  originalVersion: number;
  finalVersion: number;
  migrationsApplied: boolean;
  migrationsCount: number;
  error: boolean;
  errorMessage?: string;
}

/**
 * Runs all necessary migrations to bring CraftJSON or SectionJSON to the current schema version.
 *
 * @param data - The CraftJSON or SectionJSON to migrate
 * @param targetVersion - Optional target version (defaults to CURRENT_SCHEMA_VERSION)
 * @returns Migration result with migrated JSON and metadata
 */
export function runCraftJsonMigrations<T extends MigratableJson>(
  data: T,
  targetVersion: number = CURRENT_SCHEMA_VERSION,
): MigrationResult<T> {
  return runMigrations(data, migrations, targetVersion) as MigrationResult<T>;
}
